import LoadingImg from './assets/loading.webp';
import { ReactComponent as Logo } from './assets/logo.svg';

type LoadingPageProps = {
  message?: string;
  showLogo?: boolean;
};

function LoadingPage({ message, showLogo = false }: LoadingPageProps) {
  return (
    <div data-testid='loading-page' key='loading-page'>
      {showLogo && (
        <div className='absolute top-0 left-0 p-4'>
          <Logo />
        </div>
      )}
      <div className='flex h-screen flex-col items-center justify-center'>
        <div className='flex items-center justify-center'>
          <img src={LoadingImg} width={75} height={75} />
        </div>
        <div className='flex items-center gap-2'>{message || 'Carregando dados da página...'}</div>
      </div>
    </div>
  );
}

export default LoadingPage;
